/*
 * Copyright Mission 42 Ventures, Inc. All rights reserved.
 * Unauthorized copying, distribution, or use is prohibited.
 *
 * Control Panel -- a tabbed shell for platform-ops tooling.
 *
 * Every tab here is open to any authenticated user. Claude Usage used to live
 * here behind ClaudeMetricsReadPermission; it is now its own sidebar surface
 * at /claude-usage, gated the same way at the route and the nav item.
 */

import React, { useState } from 'react';
import { Box, Tab, Tabs, makeStyles } from '@material-ui/core';
import { Content, Header, Page } from '@backstage/core-components';
import { DependsOnWatcher } from './DependsOnWatcher';
import { ActiveRunsWatcher } from './ActiveRunsWatcher';

const useStyles = makeStyles(theme => ({
  body: { marginTop: theme.spacing(2) },
}));

export const ControlPanelPage = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);

  const tabs = [
    { label: 'Depends On Watcher', render: () => <DependsOnWatcher /> },
    { label: 'Active Runs', render: () => <ActiveRunsWatcher /> },
  ];

  const current = Math.min(tab, tabs.length - 1);

  return (
    <Page themeId="tool">
      <Header
        title="Control Panel"
        subtitle="Platform operations for the Mission 42 Backstage instance"
      />
      <Content>
        <Tabs
          value={current}
          onChange={(_e, v) => setTab(v)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map(t => (
            <Tab key={t.label} label={t.label} />
          ))}
        </Tabs>
        <Box className={classes.body}>{tabs[current].render()}</Box>
      </Content>
    </Page>
  );
};
